module.exports = __webpack_public_path__ + "img/mobile_btn9.0d48e52f.png";